import moment from 'moment';

const weekOneStartDates = {
  2025: '2025-03-29',
  2026: '2026-04-04',
  2027: '2027-04-03',
  2028: '2028-04-01',
  2029: '2029-03-31',
  2030: '2030-03-30',
};

const calculateWeekNumber = (date) => {
  const momentDate = moment(date);
  let year = momentDate.year();
  let weekOneStart = moment(weekOneStartDates[year], 'YYYY-MM-DD');

  if (momentDate.isBefore(weekOneStart)) {
    year -= 1;
    weekOneStart = moment(weekOneStartDates[year], 'YYYY-MM-DD');
  }

  const weeksPassed = momentDate.diff(weekOneStart, 'weeks');
  return weeksPassed + 1;
};

export default calculateWeekNumber;
